import React from 'react';
import PropTypes from "prop-types";
import {getFormInputCssClass, hasMessage, setupOnExtractData} from "../../../util/FormUtil";
import UserDataService from "../../common/UserDataService";
import LoginContactInfoInputComponent from "../input/LoginContactInfoInputComponent";
import {isBlank, isNotBlank} from "../../../util/StringUtil";
import AlertComponent from "../../../util/AlertComponent";

const PROP_NAME_EXISTING_PASSWORD = "existingPassword";

class UpdatePasswordInputComponent extends React.Component {

    constructor(props){
        super(props);
        this.existingPasswordChange = this.existingPasswordChange.bind(this);
        this.extractData = this.extractData.bind(this);
        this.toggleShowPassword = this.toggleShowPassword.bind(this);
        this.setMessage = this.setMessage.bind(this);
        this.hideMessage = this.hideMessage.bind(this);
        this.state = {
            message:""
        };
    }

    componentDidMount() {
        const {setFormState} = this.props;
        setFormState({ property: PROP_NAME_EXISTING_PASSWORD, data: "",
            metadata: {dirty: false, valid: false, showPassword: false}});

        setupOnExtractData(this);
        this.setMessage("Our password security has been updated. New passwords and changed passwords must be at least 12 characters long. Your current password remains valid.",
            "info");
    }

    extractData(){
        const {data} = this.props;
        return { password: data.password,
                 existingPassword: data.existingPassword };
    }

    toggleShowPassword(){
        const {setFormState, metadata} = this.props;
        const existingPasswordMetadata = metadata[PROP_NAME_EXISTING_PASSWORD];
        setFormState({property: PROP_NAME_EXISTING_PASSWORD, metadata: {...existingPasswordMetadata,
                showPassword: existingPasswordMetadata ? !existingPasswordMetadata.showPassword : false }})
    }

    existingPasswordChange(e){
        const {setFormState, metadata} = this.props;

        const passwordMetadata = { ...metadata[PROP_NAME_EXISTING_PASSWORD],
            dirty: (!isBlank(e.target.value)) ? true : false,
            valid: (!isBlank(e.target.value)) ? true : false
        };

        setFormState({property: PROP_NAME_EXISTING_PASSWORD, data: e.target.value, metadata: passwordMetadata});
    }

    setMessage(message, messageType = "error"){
        this.setState(state => ({...state, message, messageType}));
    }

    hideMessage(){
        this.setMessage(null);
    }

    render(){
        const {data, metadata, setFormState, userDataInit, userDataService} = this.props;
        let hasInputClassPassword = getFormInputCssClass(metadata, PROP_NAME_EXISTING_PASSWORD);
        let passwordDisplay = metadata[PROP_NAME_EXISTING_PASSWORD] && metadata[PROP_NAME_EXISTING_PASSWORD].showPassword ? "text" : "password";
        const existingPassword = data[PROP_NAME_EXISTING_PASSWORD];
        let passwordDisplayClass= passwordDisplay === "password"?"fa fa-eye-slash-password-input":"fa fa-eye-password-input"
        const {message, messageType} = this.state;
        return (
            <React.Fragment>
                <div className="grid">
                    <div className="grid__col-md-12 grid__col-sm-12">
                    <AlertComponent
                        message={message}
                        type={messageType}
                        onClose={this.hideMessage}
                        scrollIntoView={false}
                        closeAfterSeconds={15}
                    />
                    </div>
                </div>
                <div className="grid">
                    <div className="grid__col-md-6 grid__col-sm-12">
                            <label htmlFor={PROP_NAME_EXISTING_PASSWORD}>Current Password</label>
                            <input id={PROP_NAME_EXISTING_PASSWORD}
                                   type={passwordDisplay}
                                   autoComplete="off"
                                   style={{maxHeight: '28px'}}
                                   className={"text-input text-input--large password-input-with-eye " + passwordDisplay + hasInputClassPassword}
                                   value={existingPassword}
                                   onChange={this.existingPasswordChange}
                            />
                            <i className={passwordDisplayClass}
                               onClick={this.toggleShowPassword}
                            />
                            {
                                hasMessage(metadata, PROP_NAME_EXISTING_PASSWORD) &&
                                <div
                                    className="error display--block">{metadata[PROP_NAME_EXISTING_PASSWORD].message}</div>
                            }
                        </div>
                </div>

                    <LoginContactInfoInputComponent
                        data={data}
                        metadata={metadata}
                        setFormState={setFormState}
                        userDataInit={userDataInit}
                        userDataService={userDataService}
                        hideEmail={true}
                        hideName={true}
                        isUpdatePassword={true}
                    />

            </React.Fragment>
        );
    }

}

UpdatePasswordInputComponent.propTypes = {
    data: PropTypes.object.isRequired,
    metadata: PropTypes.object.isRequired,
    setFormState: PropTypes.func.isRequired,
    userDataInit: PropTypes.object.isRequired,
    userDataService: PropTypes.instanceOf(UserDataService).isRequired,
    email: PropTypes.string,
    onExtractData: PropTypes.func
};

export default UpdatePasswordInputComponent;